import { Label } from "@/components/ui/label";
import { OrganizationHelper } from "@/helpers/organization";
import { AppDispatch, RootState } from "@/redux";
import { useSelector, useDispatch } from "react-redux";
import { ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import { switchOrganization } from "@/services/organizationService";

export const OrganizationMenu = () => {
  const dispatch: AppDispatch = useDispatch()
  const { userData, token } = useSelector((state: RootState) => state.user)
  const { organizations } = useSelector((state: RootState) => state.organization)
  const [hasExpandedMenu, setHasExpandedMenu] = useState(false)
  const [expandedMenu, showExpandedMenu] = useState(false)

  const getMultipleOrganizationClassname = () => {
    return organizations.length > 1 ? 'cursor-pointer hover:bg-darkaccent-foreground' : ''
  }

  const onSwitchOrganization = async (orgId: string) => {
    if (!token) return;
    await dispatch(switchOrganization(token, orgId))
    showExpandedMenu(false)
  }

  useEffect(() => {
    if (userData?.isTCSAdmin === false && organizations.length > 1) {
      setHasExpandedMenu(true)
    } else {
      setHasExpandedMenu(false)
    }
  }, [userData, organizations])

  return (
    <div className="relative">
      <div
        className={'flex flex-row items-center justify-between ' +
          getMultipleOrganizationClassname() +
          (expandedMenu ? ' bg-darkaccent-foreground' : '')
        }
        onClick={() => { hasExpandedMenu && showExpandedMenu(true); }}
      >
        <Label
          className={'pl-6 flex justify-start font-semibold text-secondary my-4 text-left ' +
            getMultipleOrganizationClassname()
          }
        >
          {OrganizationHelper.getOrganizationName(userData)}
        </Label>
        {hasExpandedMenu && (
          <ChevronRight
            className={
              'h-4 w-4 mr-3 text-secondary transition duration-200 ' +
              (expandedMenu ? 'rotate-90' : '')
            }
          />
        )}
      </div>
      {expandedMenu && (
        <div className="multipleOrganizationMenu absolute p-5 bg-darkaccent bg-darkaccent-foreground">
          <p className="font-semibold text-secondary mb-3 text-sm uppercase">
            Organization
          </p>
          <div className="flex flex-col items-start">
            {organizations.map(o => (
              <div
                className="p-1 cursor-pointer hover:underline text-base font-semibold"
                key={o.id}
                onClick={() => onSwitchOrganization(o.id)}
              >
                {o.name}
              </div>
            ))}
          </div>
        </div>
      )}
      {expandedMenu && (
        <div
          onClick={() => { showExpandedMenu(false); }}
          className="transparentBackdropOverlay"
        />
      )}
    </div>
  )
}
